/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from './id-service-auth-endpoint-schema-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export * from './id-service-auth-endpoint-schema-types';
const defaultOptions = {} as const;
export type GenerateServiceAccountTokenMutationVariables = Exact<{
  input: Types.AuthenticateServiceAccountInput;
}>;


export type GenerateServiceAccountTokenMutation = { authenticateServiceAccount: { accessToken: string } };

export type DevSetupServiceAccountWithPermissionsMutationVariables = Exact<{
  input: Types.DevSetupServiceAccountWithPermissionsInput;
}>;


export type DevSetupServiceAccountWithPermissionsMutation = { devSetupServiceAccountWithPermissions: { clientId: string, clientSecret: string } | null };


export const GenerateServiceAccountTokenDocument = gql`
    mutation GenerateServiceAccountToken($input: AuthenticateServiceAccountInput!) {
  authenticateServiceAccount(input: $input) {
    accessToken
  }
}
    `;
export type GenerateServiceAccountTokenMutationFn = Apollo.MutationFunction<GenerateServiceAccountTokenMutation, GenerateServiceAccountTokenMutationVariables>;

/**
 * __useGenerateServiceAccountTokenMutation__
 *
 * To run a mutation, you first call `useGenerateServiceAccountTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateServiceAccountTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateServiceAccountTokenMutation, { data, loading, error }] = useGenerateServiceAccountTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateServiceAccountTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateServiceAccountTokenMutation, GenerateServiceAccountTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateServiceAccountTokenMutation, GenerateServiceAccountTokenMutationVariables>(GenerateServiceAccountTokenDocument, options);
      }
export type GenerateServiceAccountTokenMutationHookResult = ReturnType<typeof useGenerateServiceAccountTokenMutation>;
export type GenerateServiceAccountTokenMutationResult = Apollo.MutationResult<GenerateServiceAccountTokenMutation>;
export type GenerateServiceAccountTokenMutationOptions = Apollo.BaseMutationOptions<GenerateServiceAccountTokenMutation, GenerateServiceAccountTokenMutationVariables>;
export const DevSetupServiceAccountWithPermissionsDocument = gql`
    mutation DevSetupServiceAccountWithPermissions($input: DevSetupServiceAccountWithPermissionsInput!) {
  devSetupServiceAccountWithPermissions(input: $input) {
    clientId
    clientSecret
  }
}
    `;
export type DevSetupServiceAccountWithPermissionsMutationFn = Apollo.MutationFunction<DevSetupServiceAccountWithPermissionsMutation, DevSetupServiceAccountWithPermissionsMutationVariables>;

/**
 * __useDevSetupServiceAccountWithPermissionsMutation__
 *
 * To run a mutation, you first call `useDevSetupServiceAccountWithPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevSetupServiceAccountWithPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devSetupServiceAccountWithPermissionsMutation, { data, loading, error }] = useDevSetupServiceAccountWithPermissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDevSetupServiceAccountWithPermissionsMutation(baseOptions?: Apollo.MutationHookOptions<DevSetupServiceAccountWithPermissionsMutation, DevSetupServiceAccountWithPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevSetupServiceAccountWithPermissionsMutation, DevSetupServiceAccountWithPermissionsMutationVariables>(DevSetupServiceAccountWithPermissionsDocument, options);
      }
export type DevSetupServiceAccountWithPermissionsMutationHookResult = ReturnType<typeof useDevSetupServiceAccountWithPermissionsMutation>;
export type DevSetupServiceAccountWithPermissionsMutationResult = Apollo.MutationResult<DevSetupServiceAccountWithPermissionsMutation>;
export type DevSetupServiceAccountWithPermissionsMutationOptions = Apollo.BaseMutationOptions<DevSetupServiceAccountWithPermissionsMutation, DevSetupServiceAccountWithPermissionsMutationVariables>;